<template>
  <div>
    <a id="resultado"></a>
    <div class="listado" id="verLista" v-if="items && items.length > 0">
      <h5 class="my-4">Resultados:</h5>
      <b-table
        :fields="camposTabla"
        :items="items"
        :current-page="currentPage"
        :per-page="perPage"
        @row-selected="onRowSelected"
        select-mode="single"
        selectable
        class="table table-hover table-sm"
      >
        <template #thead-top>
          <b-tr>
            <b-th colspan="3"></b-th>
            <b-th colspan="2" class="bg-gris-medio">Puntaje Simulado</b-th>
            <b-th colspan="3" class="bg-gris-medio">Último Seleccionado</b-th>
          </b-tr>
        </template>
        <!--REGION-->
        <template v-slot:cell(region)="data">
          <span class="font-weight-bold">{{ data.value.region }}</span>
          <br />
          {{ data.value.sede }}
        </template>
        <!--PUNTAJE SIMULADO ESCALA NUEVA 2022-->
        <template v-slot:cell(puntajeSimulado)="data">
          <div
            v-if="data.value === '*'"
            v-b-tooltip.hover.top="
              'Exige Prueba Electiva que figura sin puntaje en la Simulación.'
            "
          >
            <img
              src="@/assets/img/asterisk-solid.svg"
              style="width: .5rem; margin: .3rem .3rem .3rem 0;"
              class="mr-2"
            />
          </div>
          <div v-else>{{ data.value }}</div>
        </template>
        <!--PUNTAJE SIMULADO ESCALA ANTIGUA -->
        <template v-slot:cell(puntajeSimuladoPDT)="data">
          <div
            v-if="data.value === '*'"
            v-b-tooltip.hover.top="
              'Exige Prueba Electiva que figura sin puntaje en la Simulación.'
            "
          >
            <img
              src="@/assets/img/asterisk-solid.svg"
              style="width: .5rem; margin: .3rem .3rem .3rem 0;"
              class="mr-2"
            />
          </div>
          <div v-else>{{ data.value }}</div>
        </template>
        <!--ULTIMO SELECCIONADO -2022-->
        <template v-slot:cell(admision2022)="data">
          <div
            v-if="!data.value || data.value === '0'"
            style="font-size: 1.5rem; margin: 0.1rem;"
          >
            -
          </div>
          <div v-else>{{ data.value }}</div>
        </template>
        <!--ULTIMO SELECCIONADO -2021-->
        <template v-slot:cell(admision2021)="data">
          <div
            v-if="!data.value || data.value === '0'"
            style="font-size: 1.5rem; margin: 0.1rem;"
          >
            -
          </div>
          <div v-else>{{ data.value }}</div>
        </template>
        <!--ULTIMO SELECCIONADO -2020-->
        <template v-slot:cell(admision2020)="data">
          <div
            v-if="!data.value || data.value === '0'"
            style="font-size: 1.5rem; margin: 0.1rem;"
          >
            -
          </div>
          <div v-else>{{ data.value }}</div>
        </template>
        <!--<template v-slot:cell(gratuidad)="data">
          <Gratuidad :gratuidad="data.value" styleImg="max-width: 24px;" />
        </template>-->
      </b-table>
      <div class="col col-md-12 d-block pl-1 mr-auto">
        <p
          v-if="mostrarTextoAdmisionactual || mostrarTextoAdmisionAnterior"
          class="mb-0"
        >
          <small>
            (
            <span style="font-size: 1.5rem; margin: 0.1rem;">-</span> ) Carreras
            sin postulación centralizada en procesos anteriores.
          </small>
        </p>
        <p v-if="mostrarTextoPruebaElectiva" class="mb-0">
          <small>
            (
            <img
              src="@/assets/img/asterisk-solid.svg"
              style="width: .5rem; margin: .2rem .2rem .2rem .2rem;"
              class="mr-2"
            />) Exige Prueba Electiva que figura sin puntaje en la Simulación.
          </small>
        </p>
        <p class="mb-0">
          <small
            >En el cálculo de esta simulación no están incluidas las
            ponderaciones de la/las Prueba/s de acceso especiales declaradas por
            las instituciones para el proceso de admisión 2021.
            <a :href="pdfSimulador" target="_blank">Conoce aquí</a> más
            detalles.</small
          >
        </p>
      </div>
      <b-pagination
        v-if="items && items.length > 0"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class="col-md-4 mx-auto px-0"
        align="center"
      ></b-pagination>
      <!--<div class="col-6 col-lg-3 input-lg align-self-center pr-lg-2 px-0 mb-5">
        <button
          @click="solicitarSimulacion"
          class="btn btn-blue w-100 rounded-0"
          type="button"
          id="inputGroupFileAddon1"
        >
          ENVIAR SIMULACIÓN
        </button>
      </div>-->
    </div>
  </div>
</template>

<script>
import Gratuidad from "@/components/generales/iconos/Gratuidad";
import { ModalSolicitarSimulacion } from "@/utils/BusesDeEventos.js";
export default {
  name: "ResultadosTabla",
  props: {
    resultados: { type: Array }
  },
  components: {
    Gratuidad
  },
  data() {
    return {
      camposTabla: [
        {
          key: "region",
          label: "Region/Sede",
          sortable: true,
          tdClass: "text-left"
        },
        {
          key: "institucion",
          label: "Institución",
          sortable: true,
          tdClass: "text-left font-weight-bold"
        },
        {
          key: "carrera",
          label: "Carrera",
          sortable: true,
          tdClass: "text-left"
        },
        {
          key: "puntajeSimulado",
          label: "Escala Nueva (100 - 1000)",
          sortable: true,
          thClass: "bg-gris-medio",
          tdClass: "text-azul font-weight-bold"
        },
        {
          key: "puntajeSimuladoPDT",
          label: "Escala Antigua (150 - 850)",
          sortable: true,
          thClass: "bg-gris-medio",
          tdClass: "text-azul font-weight-bold"
        },
        {
          key: "admision2022",
          label: "Admisión 2022 - Escala Antigua  (150 - 850)",
          sortable: true,
          thClass: "bg-gris-medio",
          tdClass: "text-azul font-weight-bold"
        },
        {
          key: "admision2021",
          label: "Admisión 2021 - Escala Antigua (150 - 850)",
          sortable: true,
          thClass: "bg-gris-medio",
          tdClass: "text-azul font-weight-bold"
        },
        {
          key: "admision2020",
          label: "Admisión 2020 - Escala Antigua (150 - 850)",
          sortable: true,
          thClass: "bg-gris-medio",
          tdClass: "text-azul font-weight-bold"
        }
      ],
      datos: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 8,
      pdfSimulador: CDN.PDF_SIMULADOR
    };
  },
  watch: {
    resultados() {
      this.totalRows = this.resultados.length;
    }
  },
  mounted() {
    this.totalRows = this.resultados.length;
  },
  computed: {
    items() {
      let items = [];
      let listado = this.resultados;
      for (let resul of listado) {
        items.push({
          codigo: {
            instituto: resul.codigoInstitucion,
            carrera: resul.codigoCarrera
          },
          region: { region: resul.region, sede: resul.sede },
          institucion: resul.institucion,
          carrera: resul.carrera,
          //gratuidad: resul.gratuidad,
          puntajeSimuladoPDT: resul.puntajeSimuladoPDT,
          puntajeSimulado: resul.puntajeSimulado,
          admision2022: resul.ultimoSeleccionadoA1,
          admision2021: resul.ultimoSeleccionadoA2,
          admision2020: resul.ultimoSeleccionadoA3
        });
      }
      return items;
    },
    mostrarTextoPruebaElectiva() {
      if (this.resultados.length > 0) {
        let listado = this.resultados;
        let respuesta = listado.some(res => res.puntajeSimulado === "*");
        return respuesta;
      } else {
        return false;
      }
    },
    mostrarTextoAdmisionactual() {
      if (this.resultados.length > 0) {
        let listado = this.resultados;
        if (listado.includes(res => !res.admisionActual)) {
          return true;
        }
        if (listado.includes(res => res.admisionActual === "0")) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    mostrarTextoAdmisionAnterior() {
      if (this.resultados.length > 0) {
        let listado = this.resultados;
        if (listado.some(resu => !resu.admisionAnterior)) {
          return true;
        }
        if (listado.some(resu => resu.admisionAnterior === "0")) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    }
  },
  methods: {
    onRowSelected(value) {
      let idInst = value[0].codigo.instituto;
      let idCarrea = value[0].codigo.carrera;
      this.$router.push({
        name: "FichaCarreraU",
        params: {
          idInstitucion: idInst,
          codigoCarrera: idCarrea,
          origen: "SimuladorPonderaciones"
        }
      });
    },
    solicitarSimulacion() {
      this.$ga.event({
        eventCategory: "Sistema-Acceso",
        eventAction: "simulador-ponderaciones",
        eventLabel: "abrir-modal-envio-simulacion-desktop"
      });
      ModalSolicitarSimulacion.$emit("solicitarSimulacion");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/simuladorPonderaciones/ResultadosTabla.vue